import { GxInput } from '@garpix/garpix-web-components-react'
import cn from 'classnames'
import React, { FC } from 'react'
import { JSX } from '@garpix/garpix-web-components'
import styles from './styles/index.module.scss'

export interface IInput extends JSX.GxInput {
  handleChange?: any
  className: string
  variant?: string
  error?: any
  value?: string
}

const Input: FC<IInput> = ({
  children,
  handleChange,
  className,
  value,
  variant = 'input_default',
  ...props }) => {
  return (
    <GxInput
      onGx-input={handleChange}
      value={value}
      {...props}
      className={cn(className, styles[variant])}
    >
      {children}
    </GxInput>
  );
};

export default Input;
